import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export class User extends React.Component {
  static propTypes = {
    controlIcon: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    user: PropTypes.object.isRequired,
    onSelect: PropTypes.func.isRequired,
  }

  handleAction = () => {
    this.props.onSelect(this.props.user);
  }

  render() {
    return (
      <div
        className={classNames('row py-2 clickable', { 'border-top': this.props.index > 0 })}
        onClick={this.handleAction}
      >
        <div className="col-5">
          {this.props.user.name}
        </div>

        <div className="col-6 text-muted">
          {this.props.user.officeName}
        </div>

        <div className="col-1 pe-0 text-end text-primary">
          <FontAwesomeIcon icon={this.props.controlIcon} />
        </div>
      </div>
    );
  }
}

export default User;
